module.exports = __webpack_public_path__ + "img/message-circle-blue.5dba7ca4.svg";